module.exports = __webpack_public_path__ + "models/target pole.8c6322c8.gltf";